interface IconProps {
  size?: number | string;
  color?: string;
  className?: string;
}

export function PlusMinusIcon({ size = 24, color, className }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 14 14"
      fill="currentColor"
      style={color ? { color } : undefined}
      className={className}
      aria-hidden="true"
    >
      <path d="M7.65625 0.65625C7.65625 0.292578 7.36367 0 7 0C6.63633 0 6.34375 0.292578 6.34375 0.65625V4.59375H2.40625C2.04258 4.59375 1.75 4.88633 1.75 5.25C1.75 5.61367 2.04258 5.90625 2.40625 5.90625H6.34375V9.84375C6.34375 10.2074 6.63633 10.5 7 10.5C7.36367 10.5 7.65625 10.2074 7.65625 9.84375V5.90625H11.5938C11.9574 5.90625 12.25 5.61367 12.25 5.25C12.25 4.88633 11.9574 4.59375 11.5938 4.59375H7.65625V0.65625ZM1.75 13.3438C1.75 13.7074 2.04258 14 2.40625 14H11.5938C11.9574 14 12.25 13.7074 12.25 13.3438C12.25 12.9801 11.9574 12.6875 11.5938 12.6875H2.40625C2.04258 12.6875 1.75 12.9801 1.75 13.3438Z" />
    </svg>
  );
}
